<template>
  <el-dialog
    title="移动"
    :visible.sync="$parent.moveDialogStatus"
    class="move-dialog"
  >
    <div class="move-main">
      <el-scrollbar style="height: 100%; overflow-x: hidden">
        <el-tree
          node-key="id"
          :props="$parent.props"
          :load="$parent.loadNode"
          ref="tree"
          @node-click="$parent.moveTreeClick"
          lazy
        >
          <span class="custom-tree-node" slot-scope="{ node }">
            <img src="@/assets/image/folder.png" width="20" height="18" />
            <span>{{ node.label }}</span>
          </span>
        </el-tree>
      </el-scrollbar>
    </div>
    <span slot="footer" class="dialog-footer btn-wrap">
      <el-button @click="$parent.moveDialogStatus = false">取 消</el-button>
      <el-button type="primary" @click.stop="moveSubmit">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
export default {
  methods: {
    moveSubmit() {
      this.$emit("submit");
    },
  },
};
</script>

<style></style>
